import {
    GET_CARDS,
    GET_TABLE,
    GET_PAYMENTMETHON_LIST,
    GET_STATE_LOADING
} from "@/views/recognition/store/types/types.js";

const getters = {
    [GET_CARDS]: state => state.cards,
    [GET_TABLE]: state => state.table,
    [GET_PAYMENTMETHON_LIST]: state => state.typePaymentMethon,
    [GET_STATE_LOADING]: state => state.loadingCode
};

export default getters;